module.exports = __webpack_public_path__ + "img/hair_front_male_long.cc2bfd54.png";